<template>
  <section id="cqc">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="title2">
            <h3><span>CQC overview and inspections</span></h3>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div id="cqcReport" class="col-md-12"></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  mounted() {
    let eScript = document.createElement("script");
    eScript.setAttribute(
      "src",
      "https://www.cqc.org.uk/sites/all/modules/custom/cqc_widget/widget.js?data-id=1-3769281126&data-host=www.cqc.org.uk&type=location"
    );
    document.getElementById("cqcReport").appendChild(eScript);
  },
};
</script>
